import { Component, EventEmitter, Output } from '@angular/core';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { NavigationService } from 'services/navigation.service';

export interface HasResult {
	result: EventEmitter<Object | undefined>;
}

@Component({
	selector: 'notification-popup',
	styleUrls: ['./notification-popup.component.scss'],
	templateUrl: './notification-popup.component.html',
	imports: [Layout, TranslatePipe]
})
export class NotificationPopupComponent implements HasResult {

	title?: string;
	text?: string;
	details?: string;
	buttons: { text: string, type: 'confirm' | 'neutral' | 'reject' | 'ghost', value?: Object }[] = [{ text: 'general.close', type: 'neutral' }];

	@Output()
	result = new EventEmitter<Object | undefined>();

	constructor(private readonly navigation: NavigationService) { }

	closeView(result?: Object) {
		this.result.next(result);
		this.result.complete();
		this.navigation.closeView(this);
	}
}

@Component({
	selector: 'notification-popup-error',
	styleUrls: ['./notification-popup.component.scss'],
	templateUrl: './notification-popup-error.component.html',
	imports: [Layout, TranslatePipe]
})
export class NotificationPopupErrorComponent extends NotificationPopupComponent {

	stacktrace?: { text: string, isOwnCode: boolean }[];
	showStacktrace = false;

	toggleStacktrace() {
		this.showStacktrace = !this.showStacktrace;
	}

}
